import React from "react";
import { useTranslation } from "react-i18next";

const Blog = () => {
    const { t } = useTranslation();

    return (
        <div className="home-container page-content" style={{ color: "black", textAlign: "center" }}>
            <h1>{t("blog.title")}</h1>
        </div>
    );
};

export default Blog;
